import { RouteComponentProps, useLocation } from "@gatsbyjs/reach-router";
import { APAsyncButton, APCard, APColumn, APExpanded, APRow, APSizedBox, APText, getIt, handleErrorMessage, showErrorDialog } from "ap-components";
import React, { useEffect, useState } from "react";
import numberToWord from "../../Common/numberToWords";
import SharedPrefs from "../../Services/SharedPrefs";
import MandateModel from "../../Models/Mandate";
import { BankAccount } from "./BankAccount";
import LoadingState from "./LoadingState";
import MandateScrollContainer from "./MandateScrollContainer";
import MutualFundApiServices from "../../Services/MutualFundServices";

export default function MultipleMandate(props: RouteComponentProps) {
    var location = useLocation();
    const token = new URLSearchParams(location.search).get("tkn");
    const mandateId = new URLSearchParams(location.search).get("mandateId");

    if (token) {
        getIt(SharedPrefs).setItem("mandateTkn", token);
    }

    const [mandates, setMandates] = useState<MandateModel[]>();

    useEffect(() => {
        if (!mandateId) {
            getAllUnapprovedMandates()
        }
    }, [])

    if (!token) {
        window.location.href = '/'
        showErrorDialog("Unauthorized Access");
        return <></>
    }

    if (mandateId) {
        window.location.href = `/mandate/${mandateId}/info`;
        return <></>
    }

    async function getAllUnapprovedMandates() {
        if (!token) {
            return
        }

        try {
            const res = await getIt(MutualFundApiServices).getAllUnapprovedMandates(token);
            setMandates(res);
        } catch (error) {
            handleErrorMessage(error);
        }
    }

    if (!mandates) {
        return (
            <LoadingState />
        );
    }



    if (mandates.length === 1) {
        window.location.href = `/mandate/${mandates[0]._id}/info`;
        return <></>
    }

    return (
        <MandateScrollContainer
            scrollContent={
                <APColumn crossAxisAlignment="stretch">
                    <APText style={{ fontSize: '16px', fontWeight: 600, lineHeight: 1.5, color: "#232730" }}>Setup AutoPay</APText>
                    <APSizedBox height="8px" />
                    <APExpanded>
                        <APText style={{ fontSize: '14px', lineHeight: 1.43, color: "#41495b" }}>
                            You currently have {numberToWord(mandates.length)} AutoPay process to complete. Click one to proceed
                        </APText>
                    </APExpanded>
                    <APSizedBox height="8px" />
                    <APColumn gap="8px" crossAxisAlignment="stretch">
                        {
                            mandates.map(mandate => (
                                <MandateCard key={mandate._id} mandate={mandate} />
                            ))
                        }
                    </APColumn>
                </APColumn>
            }
        />
    )
}

function MandateCard({ mandate }: { mandate: MandateModel }) {

    const mandateType = mandate.getMandateType()

    return (
        <APCard style={{ borderRadius: "8px" }}>
            <BankAccount mandate={mandate} />
            <APSizedBox height="16px" />
            <APRow mainAxisAlignment="spaceBetween" crossAxisAlignment="center">
                <APText style={{ fontSize: "12px", lineHeight: 1.33, color: "#41495b" }}>MANDATE MODE: </APText>
                <APText style={{ fontSize: "14px", lineHeight: 1.43, color: "#232730", fontWeight: 600 }}>{mandateType}</APText>
            </APRow>
            {
                mandateType === "Online" &&
                <>
                    <APSizedBox height="4px" />
                    <APText style={{ fontSize: "12px", lineHeight: "16px", color: "#41495b", textAlign: "end" }}>Netbanking/Debit Card</APText>
                </>
            }

            <APSizedBox height="8px" />
            <APRow mainAxisAlignment="spaceBetween">
                <APText style={{ fontSize: "12px", lineHeight: 1.33, color: "#41495b" }}> YOUR AUTOPAY LIMIT: </APText>
                <APText style={{ fontSize: "14px", lineHeight: 1.43, color: "#232730", fontWeight: 600 }}>{parseFloat(mandate.mandateAmount).currency()}</APText>
            </APRow>

            <APSizedBox height="18px" />
            <APAsyncButton onClick={async () => {
                window.location.href = `/mandate/${mandate._id}/info`;
            }}>Setup</APAsyncButton>
        </APCard>
    )
}